import { put, takeLatest, call } from 'redux-saga/effects';
import Pagination from '../interfaces/common/pagination';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';
import { PayloadAction } from '@reduxjs/toolkit';
import Paging from '../interfaces/common/paging';
import ReconcileStatus from '../interfaces/output/reconcileStatus';
import ReconcileStatusApi from '../api/reconcileStatusApi';
import { fetchReconcileStatusByIdError, fetchReconcileStatusByIdSuccess, fetchReconcileStatusesError, fetchReconcileStatusesSuccess } from '../reducers/reconcileStatusReducer';

function* doFetchReconcileStatus(action: PayloadAction<string>) {
    const reconcileStatusId = action.payload;
    try {
        const response: ReconcileStatus = yield call(ReconcileStatusApi.fetchReconcileStatusById, reconcileStatusId);
        yield put(fetchReconcileStatusByIdSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchReconcileStatusByIdError(error as HttpErrorResponse));
    }
}

function* doFetchReconcileStatuses(action: PayloadAction<{ paging: Paging}>) {
    const { paging } = action.payload;
    try {
        const response: Pagination<ReconcileStatus> = yield call(ReconcileStatusApi.fetchReconcileStatuses, paging);
        yield put(fetchReconcileStatusesSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchReconcileStatusesError(error as HttpErrorResponse));
    }
}

export default [
    takeLatest('reconcileStatus/fetchReconcileStatusById', doFetchReconcileStatus),
    takeLatest('reconcileStatus/fetchReconcileStatuses', doFetchReconcileStatuses)
];

